export var LightType;
(function (LightType) {
    LightType["POINT_LIGHT"] = "Point Light";
    LightType["SPOT_LIGHT"] = "Spot Light";
    LightType["DIRECTED_SHADOW_POINT_LIGHT"] = "Directed Shadow Point Light";
    LightType["LINE_LIGHT"] = "Line Light";
    LightType["DIRECTIONAL_LIGHT"] = "Directional Light";
})(LightType || (LightType = {}));
//# sourceMappingURL=LightType.js.map